import { createApp, h } from 'vue'
import Index            from './Pages/Shop/Index'
import PrimeVue 		from 'primevue/config'
import FloatingVue 		from 'floating-vue'

const app = createApp({
    render: () => h(Index)
})

app.use(PrimeVue)
app.use(FloatingVue,  {container: '#pfizerShopApp'})

app.mount('#pfizerShopApp')